import {saveAs} from 'file-saver';
import {t} from 'i18next';
import moment, {now} from 'moment';
import {Card} from 'primereact/card';
import PropTypes from 'prop-types';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import CopyToClipboard from 'react-copy-to-clipboard';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionButton from '../components/ActionButton';
import {CustomDialog} from '../components/CustomDialog';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import CriteriaCalendarRangeComponent from '../components/criteria/CriteriaCalendarRangeComponent';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaNumberRangeComponent from '../components/criteria/CriteriaNumberRangeComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import {amountNet, baseReportCsv, baseReportPdf, baseXLSXReport, currencyFormat} from '../report/ReportUtils';
import InvoiceService from '../services/InvoiceService';
import ProfileService from '../services/ProfileService';
import SettingSerivce from '../services/SettingService';
import { InvoiceAttachmentDownloadComponent } from '../components/InvoiceAttachmentDownloadComponent';
import { PrintButtonComponent } from '../report/ReportUtils';

class InvoiceListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new InvoiceService());
        this.settingService = new SettingSerivce();
        this.profileService = new ProfileService();
        this.state = {
            list: [],
            unpaidInvoices: {toPayAmount: 0, count: 0},
            selectedList: [],
            selectAll: false,
            loading: true,
            unpaidInvoicesLoading: true,
            pragmaLoading: false,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            statusOptions: [
                {enumValue: 'ALL', label: t(`InvoiceStatus.ALL`)},
                {enumValue: 'PAID', label: t(`InvoiceStatus.PAID`)},
                {enumValue: 'UNPAID', label: t(`InvoiceStatus.UNPAID`)},
            ],
            showInvoicesOptions: [
                {enumValue: 'ALL', label: t(`InvoiceShowOptions.ALL`)},
                {enumValue: 'ONLY_PETROL', label: t(`InvoiceShowOptions.ONLY_PETROLS`)},
                {enumValue: 'ONLY_EV', label: t(`InvoiceShowOptions.ONLY_EV`)},
            ],
            pragmaPaymentPeriods: [{value: '14', label: t(`invoice.pragma.14`)}, {value: '21', label: t(`invoice.pragma.21`)}, {value: '30', label: t(`invoice.pragma.30`)}],
            pragmaCosts: undefined,
            element: [],
            showInvoiceOption: '',
            roleTypeOptions: [],
            lastInvoice: undefined,
            currentUser: this.authService.getProfile(),
            paymentRecipient: 'Anwim S.A. ul. Stańczyka 3, 01-237 Warszawa',
            showDialog: false,
            invoiceTraditionalDialog: false,
            invoicePragmaDialog: false,
            pragmaAgreement: false,
            xfxStartDate: undefined,
        };
        this.user = this.authService.getProfile();
        this.invoicePayToTemplate = this.invoicePayToTemplate.bind(this);
        this.invoiceAmountTemplate = this.invoiceAmountTemplate.bind(this);
        this.renderPaymentDetails = this.renderPaymentDetails.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getListTitle() {
        return 'invoice.listTitle';
    }

    updateListElements(list) {
        if (list && list.length > 0) {
            list.forEach((element) => {
                if (element.invoiceDate) {
                    element.invoiceDate = element.invoiceDate ? new Date(element.invoiceDate) : undefined;
                }
            });
        }
        if (list && list.length > 0 && this.state.showInvoiceOption === 'ONLY_EV') {
            list = list.filter((element) => element.ev === true);
        }
        if (list && list.length > 0 && this.state.showInvoiceOption === 'ONLY_PETROL') {
            list = list.filter((element) => element.ev === false);
        }
        return list;
    }

    updateSearchCriteria(criteria) {
        return {
            dateFrom: criteria.dateFrom ? new Date(criteria.dateFrom) : undefined,
            dateTo: criteria.dateTo ? new Date(criteria.dateTo) : undefined,
            amountFrom: criteria.amountFrom,
            amountTo: criteria.amountTo,
            invoiceNumber: criteria.invoiceNumber,
            ksefId: criteria.ksefId,
            status: this.props.statusSc ? this.props.statusSc : criteria.status,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {

        return {
            dateFrom: !this.props.embedded ? moment(new Date()).subtract(90, 'days').toDate() : undefined,
            dateTo: undefined,
            amountFrom: undefined,
            amountTo: undefined,
            invoiceNumber: '',
            ksefId: '',
            status: this.props.statusSc,
            id: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'invoiceDate',
            sortAsc: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.defaultLoading) {
            this.setState({loading: true});
        }
    }

    initializeFromBackend() {
        const {t} = this.props;
        const {currentUser} = this.state;

        this.settingService.getValue('XFX_START_DATE').then((resp) =>
            this.setState({
                xfxStartDate: resp.value,
            })
        );
        this.service
            .getUnpaidList()
            .then((data) => {
                if (this._isMounted) {
                    this.setState({
                        unpaidInvoices: data,
                        unpaidInvoicesLoading: false,
                    });
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        unpaidInvoices: {toPayAmount: 0, count: 0},
                        unpaidInvoicesLoading: false,
                    });
                }
            });
        if (
            this.user &&
            ((this.user.agreementSapRole === 'FLOTA' && this.isUserHasAnyPermission('PERMISSION_VIEW_PROFILE', 'PERMISSION_EDIT_PROFILE')) ||
                this.user.agreementSapRole === 'HURT' ||
                this.user.agreementSapRole === 'FRANCZYZA' ||
                this.user.agreementSapRole === 'HURT EPT')
        ) {
            this.profileService
                .getRecipientAndBankName()
                .then((response) => {
                    this.setState({
                        paymentRecipient: response.recipient,
                    });
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileRecipientAndBankNameError'));
                });
        }
        if (currentUser?.agreementType === 'CASH') {
            this.service
                .getLastInvoice()
                .then((lastInvoice) => {
                    if (!lastInvoice.result && lastInvoice.result !== false) {
                        this.setState({
                            lastInvoice,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorMessage(t('error.getLastInvoiceError'));
                });
        }
    }

    initPayment(invoice) {
        const requestBody = {
            invoiceNumber: invoice?.invoiceNumber,
            paymentType: 'INVOICE',
            amount: invoice?.toPayAmount,
            country: null,
            language: null,
            currency: null,
        };
        this.service
            .p24PaymentToken(requestBody)
            .then((data) => {
                window.open(data.token);
            })
            .catch(() => {
                this.messages.show({
                    severity: 'error',
                    summary: 'Błąd',
                    detail: 'Nie udało się zainicjalizować płatności',
                });
            });
    }
    initPragmaPayment(invoice) {
        const requestBody = {
            invoiceNumber: invoice?.invoiceNumber,
            paymentType: 'INVOICE',
            amount: invoice?.toPayAmount,
            country: null,
            language: null,
            currency: null,
        };
        this.service
            .p24PaymentToken(requestBody)
            .then((data) => {
                window.open(data.token);
            })
            .catch(() => {
                this.messages.show({
                    severity: 'error',
                    summary: 'Błąd',
                    detail: 'Nie udało się zainicjalizować płatności',
                });
            });
    }

    countPragmaCosts(period, value) {
        const requestBody = {
            value: {
                amount: value,
                currency: 'PLN',
            },
            defermentDays: period,
            networkCode: null,
        };
        this.service
            .countPragmaCosts(requestBody.value.amount, requestBody.defermentDays)
            .then((data) => {
                //window.open(data.token);
                this.setState({pragmaCosts: data.value.amount});
            })
            .catch(() => {
                this.messages.show({
                    severity: 'error',
                    summary: 'Błąd',
                    detail: 'Brak komunikacji z systemem odroczonej płatności',
                });
            });
    }

    getCriteriaName() {
        return 'invoice-list-sc';
    }

    getContainerListName() {
        return 'invoice-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleValidForm() {
        this.unblockUi();
    }

    showDownloadAttachmentMessage(type, text){
        if(type === 'INFO'){
            this.showInfoMessage(text);
        }
        if(type === 'ERROR'){
            this.showErrorMessage(text);
        }
    }

    renderPaymentDetails() {
        const {t} = this.props;
        const {currentUser, unpaidInvoices} = this.state;
        return !this.props.hidePaymentDetails ? (
            <div className='invoice-payment-details'>
                <div className={currentUser.agreementType === 'CASH' ? 'row cash' : 'row rest'}>
                    {currentUser.agreementType === 'CASHLESS' ||
                    currentUser.agreementSapRole === 'HURT' ||
                    currentUser.agreementSapRole === 'FRANCZYZA' ||
                    currentUser.agreementSapRole === 'HURT EPT' ? (
                        <div className='col-md-4 col-sm-6'>
                            <Card
                                header={
                                    <div className=''>
                                        <img src='/images/ico_cards_wallet.svg' className='card-icon' alt={t('contact.wallet')} />
                                        {`${t('invoice.invoicesToBePaid')} ${unpaidInvoices.count > 0 ? `(${unpaidInvoices.count})` : ''}`}
                                    </div>
                                }
                            >
                                <BlockUi
                                    tag='div'
                                    blocking={this.state.unpaidInvoicesLoading}
                                    loader={this.loader}
                                    loaderType='small-loader'
                                    horizontal
                                >
                                    {unpaidInvoices.count > 0 ? (
                                        <div
                                            className={`invoices ${
                                                unpaidInvoices.afterDeadline ? 'unpaid-afterDeadline' : 'unpaid-beforeDeadline'
                                            }`}
                                        >
                                            <NumberFormat
                                                value={unpaidInvoices.toPayAmount}
                                                displayType={'text'}
                                                thousandSeparator=' '
                                                decimalSeparator=','
                                                fixedDecimalScale
                                                decimalScale={2}
                                                renderText={(value, props) => value}
                                                suffix={` ${t('currency.pln')}`}
                                            />
                                        </div>
                                    ) : (
                                        <div className='invoices-paid'>{t('invoice.invoicesPaid')}</div>
                                    )}
                                    {unpaidInvoices.count === 1 ? (
                                        <div className='pay-date-pay24'>
                                            <InputTextComponent
                                                id='invoiceDate'
                                                name='invoiceDate'
                                                label={`${t('invoice.payDate')}:`}
                                                colClass='col-md-6 col-sm-12 pay-date'
                                                value={moment(unpaidInvoices.payDate).format('DD-MM-YYYY')}
                                                viewMode={'VIEW'}
                                                validator={this.validator}
                                                validators=''
                                                onChange={this.handleChange}
                                            />
                                            <ActionButton
                                                label={
                                                    unpaidInvoices.toPayAmount === 0 ? (
                                                        t('invoice.paid')
                                                    ) : (!unpaidInvoices?.sapDocument ||
                                                          (unpaidInvoices?.toPayAmount > 0 &&
                                                              unpaidInvoices?.invoiceGrossAmount > 15000)) &&
                                                      this.isUserInRole('ROLE_FLEET') ? (
                                                        t('invoice.payTraditional')
                                                    ): (unpaidInvoices.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL')) ? (
                                                        t('invoice.payTraditional')
                                                    ) 
                                                    : (!unpaidInvoices?.sapDocument || unpaidInvoices?.toPayAmount >= 15000) &&
                                                      !this.isUserInRole('ROLE_FLEET') ? (
                                                        t('invoice.payTraditional')
                                                    )  : unpaidInvoices?.sapDocument &&
                                                      unpaidInvoices?.toPayAmount > 0 &&
                                                      unpaidInvoices?.invoiceGrossAmount <= 15000 &&
                                                      this.isUserInRole('ROLE_FLEET') ? (
                                                        <div>
                                                            <div>{t('invoice.pay')}</div>
                                                            <div className='pay24'>{t('invoice.pay24')}</div>
                                                        </div>
                                                    ) : unpaidInvoices?.sapDocument &&
                                                      unpaidInvoices?.toPayAmount < 15000 &&
                                                      !this.isUserInRole('ROLE_FLEET') ? (
                                                        <div>
                                                            <div>{t('invoice.pay')}</div>
                                                            <div className='pay24'>{t('invoice.pay24')}</div>
                                                        </div>
                                                    ) : null
                                                }
                                                handleClick={(e) => {
                                                    e.preventDefault();
                                                    if (unpaidInvoices?.toPayAmount === 0) {
                                                    } else if (
                                                        (!unpaidInvoices?.sapDocument ||
                                                            (unpaidInvoices?.toPayAmount > 0 &&
                                                                unpaidInvoices?.invoiceGrossAmount > 15000)) &&
                                                        this.isUserInRole('ROLE_FLEET')
                                                    ) {
                                                        this.setState({invoiceTraditionalDialog: true});
                                                    }
                                                    else if (unpaidInvoices?.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL')){
                                                        this.setState({invoiceTraditionalDialog: true});
                                                    }  
                                                    else if (
                                                        (!unpaidInvoices?.sapDocument || unpaidInvoices?.toPayAmount >= 15000) &&
                                                        !this.isUserInRole('ROLE_FLEET')
                                                    ) {
                                                        this.setState({invoiceTraditionalDialog: true});
                                                    } 
                                                    else if (
                                                        unpaidInvoices?.sapDocument &&
                                                        unpaidInvoices?.toPayAmount > 0 &&
                                                        unpaidInvoices?.invoiceGrossAmount <= 15000 &&
                                                        this.isUserInRole('ROLE_FLEET')
                                                    ) {
                                                        this.initPayment(unpaidInvoices);
                                                    } else if (
                                                        unpaidInvoices?.sapDocument &&
                                                        unpaidInvoices?.toPayAmount > 0 &&
                                                        unpaidInvoices?.toPayAmount < 15000 &&
                                                        !this.isUserInRole('ROLE_FLEET')
                                                    ) {
                                                        this.initPayment(unpaidInvoices);
                                                    }
                                                }}
                                                variant={`next-button ${
                                                    ((!unpaidInvoices?.sapDocument ||
                                                        (unpaidInvoices?.toPayAmount > 0 && unpaidInvoices?.invoiceGrossAmount > 15000)) &&
                                                        this.isUserInRole('ROLE_FLEET')) ||
                                                         (unpaidInvoices?.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL')) ||
                                                    ((!unpaidInvoices?.sapDocument || unpaidInvoices?.toPayAmount >= 15000) &&
                                                        !this.isUserInRole('ROLE_FLEET')) 
                                                        ? 'pay-traditional-button'
                                                        : (unpaidInvoices?.sapDocument &&
                                                              unpaidInvoices?.toPayAmount > 0 &&
                                                              unpaidInvoices?.invoiceGrossAmount <= 15000 &&
                                                              this.isUserInRole('ROLE_FLEET')) ||
                                                          (unpaidInvoices?.sapDocument &&
                                                              unpaidInvoices?.toPayAmount > 0 &&
                                                              unpaidInvoices?.toPayAmount < 15000 &&
                                                              !this.isUserInRole('ROLE_FLEET'))
                                                        ? 'pay24-button'
                                                        : ''
                                                }`}
                                                disabled={(this.user?.agreementSapRole === 'FLOTA' && !this.isUserHasPermission('PERMISSION_EDIT_INVOICES')) || 
                                                    this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                                            />
                                        </div>
                                    ) : null}
                                </BlockUi>
                            </Card>
                        </div>
                    ) : currentUser.agreementType === 'CASH' ? (
                        <div className='col-12'>
                            <Card
                                header={
                                    <div className=''>
                                        <img src='/images/ico_cards_wallet.svg' className='card-icon' alt={t('contact.wallet')} />
                                        {t('invoice.lastInvoiceAmount')}
                                    </div>
                                }
                            >
                                <div className='invoices'>
                                    {!!this.state.lastInvoice ? (
                                        <NumberFormat
                                            value={this.state?.lastInvoice?.amount}
                                            displayType={'text'}
                                            thousandSeparator=' '
                                            decimalSeparator=','
                                            fixedDecimalScale
                                            decimalScale={2}
                                            renderText={(value, props) => value}
                                            suffix={` ${t('currency.pln')}`}
                                        />
                                    ) : (
                                        <div className='invoices'>-</div>
                                    )}
                                </div>
                            </Card>
                        </div>
                    ) : null}
                    {currentUser.agreementType !== 'CASH' ? (
                        <div
                            className={
                                currentUser.agreementType === 'CASHLESS' ||
                                currentUser.agreementSapRole === 'HURT' ||
                                currentUser.agreementSapRole === 'FRANCZYZA' ||
                                currentUser.agreementSapRole === 'HURT EPT'
                                    ? 'col-md-8 col-sm-12'
                                    : 'col-12'
                            }
                        >
                            <Card
                                header={
                                    <div>
                                        <img src='/images/ico_cards_wallet.svg' className='card-icon' alt={t('contact.wallet')} />
                                        {t('invoice.paymentDetails')}
                                    </div>
                                }
                            >
                                <div className='row'>
                                    <InputTextComponent
                                        id='recipient'
                                        name='recipient'
                                        label={t('invoice.paymentRecipient')}
                                        colClass='col-md-6 col-sm-12'
                                        value={this.state.paymentRecipient}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                        onChange={this.handleChange}
                                    />
                                    <InputTextComponent
                                        id='bankAccount'
                                        name='bankAccount'
                                        label={t('invoice.bankAccount')}
                                        colClass='col-md-6 col-sm-12'
                                        value={this.user.agreementBankAccountNumber}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                        onChange={this.handleChange}
                                        renderValue={() => {
                                            return (
                                                <div className='bank-name-and-account'>
                                                    <span>{this.user.agreementBankAccountNumber}</span>
                                                    <CopyToClipboard
                                                        text={
                                                            !!this.user.agreementBankAccountNumber
                                                                ? this.user.agreementBankAccountNumber.replace(/^\D+/g, '')
                                                                : ''
                                                        }
                                                        onCopy={() => this.showSuccessMessage(t('balance.copyBankAccountSuccess'))}
                                                    >
                                                        <img
                                                            src='/images/ico_copy.svg'
                                                            className='card-icon'
                                                            alt={t('balance.copyBankAccount')}
                                                        />
                                                    </CopyToClipboard>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>
                            </Card>
                        </div>
                    ) : null}
                </div>
            </div>
        ) : null;
    }

    renderCriteria() {
        const {t} = this.props;
        const {currentUser} = this.state;
        return (
            <div className='row'>
                <CriteriaCalendarRangeComponent
                    id='invoiceDate-sc'
                    idFrom='invoiceDateFrom-sc'
                    idTo='invoiceDateTo-sc'
                    name='invoiceDate'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    label={t('invoice.invoiceDate')}
                    colClass='col-xl-6 col-lg-6 col-sm-6'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    sharedLabel
                    renderDash
                    placeholderFrom={t('cards.from')}
                    placeholderTo={t('cards.to')}
                    inputsClassName='col-6'
                />
                <CriteriaNumberRangeComponent
                    idFrom='amountFrom-sc'
                    idTo='amountTo-sc'
                    nameFrom='amountFrom'
                    nameTo='amountTo'
                    name='amount'
                    renderDash
                    label={t('invoice.amountFilter')}
                    labelFrom={''}
                    labelTo={''}
                    showButtons={false}
                    colClass='col-xl-6 col-lg-6 col-sm-6'
                    value={this.state.criteria.login}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    inputsClassName='col-6'
                    allowEmpty
                />
                <CriteriaTextComponent
                    id='invoiceNumber-sc'
                    name='invoiceNumber'
                    label={t('invoice.invoiceNumberFilter')}
                    colClass='col-xl-3 col-lg-6 col-sm-6'
                    value={this.state.criteria.invoiceNumber}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('invoice.status')}
                    colClass='col-xl-3 col-lg-6 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statusOptions}
                    placeholder={t('InvoiceStatus.ALL')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                />
                <InputDropdownComponent
                    id='showInvoices'
                    name='showInvoices'
                    label={t('invoice.showOptions')}
                    colClass='col-xl-3 col-lg-6 col-sm-6'
                    value={this.state.showInvoiceOption}
                    validator={this.validator}
                    options={this.state.showInvoicesOptions}
                    onChange={this.handleChangeDropdown.bind(this)}
                    placeholder={t('InvoiceShowOptions.ALL')}
                    viewMode={'EDIT'}
                    enumMode
                    optionValue='enumValue'
                    showClear
                    rendered={
                        currentUser.agreementSapRole !== 'HURT' &&
                        currentUser.agreementSapRole !== 'FRANCZYZA' &&
                        currentUser.agreementSapRole !== 'HURT EPT'
                    }
                />
                {this.isKsefOn() ? <CriteriaTextComponent
                    id='ksefNumber-sc'
                    name='ksefId'
                    label={t('invoice.ksef.ksefNumberFilter')}
                    colClass='col-xl-3 col-lg-6 col-sm-6'
                    value={this.state.criteria.ksefId}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                /> : null}
              
            </div>
        );
    }
    handleChangeDropdown(a, b, c) {
        let tempVal = c.value;
        this.setState({showInvoiceOption: tempVal});
        this.refreshTable();
    }

    renderP24Banner() {
        const {t} = this.props;
        return (
            <div className='p24-banner'>
                <img alt={t('invoice.pay24')} src='/images/Przelewy24_logo.svg' className='p24-banner-logo' />
            </div>
        );
    }

    invoiceAmountTemplate(rowData) {
        const {t} = this.props;
        return (
            <span className='invoice-amount-container'>
                <span className='invoice-amount'>
                    {t('invoice.amountGross')}
                    <NumberFormat
                        value={rowData.amount}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
                <span className='invoice-amount-vat'>
                    {t('invoice.amountVat')}
                    <NumberFormat
                        value={rowData.amountVat}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
                <span className='invoice-amount-netto'>
                    {t('invoice.amountNet')}
                    <NumberFormat
                        value={rowData.sapDocument ? rowData.amountNetto : rowData.amount - rowData.amountVat}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
            </span>
        );
    }

    invoicePayToTemplate(rowData) {
        const {t} = this.props;
        const {currentUser} = this.state;
        let payDateValid = rowData.payDate && moment(rowData.payDate).isValid();
        let daysAfterDeadline = payDateValid ? moment(rowData.payDate).diff(now(), 'days') : null;
        return (
            <span
                className={`invoice-payDate-container ${
                    rowData.toPayAmount > 0 ? (daysAfterDeadline && daysAfterDeadline >= 0 ? 'before-deadline' : 'after-deadline') : ''
                }`}
            >
                <span className='invoice-payDate'>{payDateValid ? moment(rowData.payDate).format('DD-MM-YYYY') : ''}</span>
                {rowData.toPayAmount > 0 && currentUser.agreementType !== 'CASH' ? (
                    <span className='invoice-payDate-status'>
                        {payDateValid && daysAfterDeadline >= 0 ? t('invoice.beforeDeadline', {count: daysAfterDeadline + 1}) : ''}
                        {payDateValid && daysAfterDeadline < 0 ? t('invoice.afterDeadline', {count: -daysAfterDeadline}) : ''}
                    </span>
                ) : null}
            </span>
        );
    }
    openInNewTab(url) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    sendInvoiceIdToPragma(rowData, daysNumber) {
        this.setState({ pragmaLoading: true });
        this.service
            .generatePragmaRequestData(rowData.invoiceNumber, daysNumber)
            .then((response) => {
                if (response !== null) {
                    this.openInNewTab(response.formUrl);
                    this.showSuccessMessage("Wniosek został otwarty w nowym oknie")
                }
                this.setState({pragmaLoading:false});
            })
            .catch((err) => {
                if(err.message !== null && err.message !== "" && err.message !== undefined){
                    this.showErrorMessage(err.message);
                } else {
                     this.showErrorMessage(t('invoice.downloadPragmaFormUrlError'));
                     
                    }
                    this.setState({pragmaLoading:false});
            });
    }

    actionTemplate(rowData) {
        const {t} = this.props;
        const {currentUser} = this.state;
        return (
            <div className='invoice-action-template'>
                <div className='row'>
                    {this.isUserInRole('ROLE_FLEET') && currentUser.agreementType === 'CASHLESS' && rowData?.pragmaVisible === true ? (
                        <ActionButton
                            id='openPragmaPopUp'
                            label={
                                rowData?.toPayAmount === 0 ? null : (
                                    <div>
                                        <div className='pragmaBtn'>{t('invoice.pragmaPay')}</div>
                                    </div>
                                )
                            }
                            handleClick={(e) => {
                                e.preventDefault();
                                if (rowData?.toPayAmount > 0) {
                                    this.setState({invoicePragmaDialog: true, invoicePragmaData: rowData});
                                }
                            }}
                            variant={`next-button ${'button-list-pragma'}`}
                            key={'view-button'}
                            rendered={rowData?.pragmaVisible === true && currentUser.agreementType !== 'CASH'}
                            disabled={(this.user?.agreementSapRole === 'FLOTA' && !this.isUserHasPermission('PERMISSION_EDIT_INVOICES')) || 
                                this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                        />
                    ) : null}

                    <ActionButton
                        label={
                            rowData?.toPayAmount === 0 ? (
                                t('invoice.paid')
                            ) : ((!rowData?.sapDocument || (rowData?.toPayAmount > 0 && rowData?.amount > 15000)) &&
                                  this.isUserInRole('ROLE_FLEET')) ||
                              ((!rowData?.sapDocument || rowData?.toPayAmount >= 15000) && !this.isUserInRole('ROLE_FLEET')) 
                              ||  (rowData.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL'))
                              ? (
                                t('invoice.payTraditional')
                            ) : 
                            (rowData?.sapDocument &&
                                  rowData?.toPayAmount > 0 &&
                                  rowData?.amount <= 15000 &&
                                  this.isUserInRole('ROLE_FLEET')) ||
                              (rowData?.sapDocument &&
                                  rowData?.toPayAmount > 0 &&
                                  rowData?.toPayAmount < 15000 &&
                                  !this.isUserInRole('ROLE_FLEET')) ? (
                                <div>
                                    <div>{t('invoice.pay')}</div>
                                    <div className='pay24'>{t('invoice.pay24')}</div>
                                </div>
                            ) : null
                        }
                        handleClick={(e) => {
                            e.preventDefault();
                            if (rowData?.toPayAmount === 0) {
                            } else if (
                                ((!rowData?.sapDocument || (rowData?.toPayAmount > 0 && rowData?.amount > 15000)) &&
                                    this.isUserInRole('ROLE_FLEET')) ||
                                     (rowData.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL')) ||
                                ((!rowData?.sapDocument || rowData?.toPayAmount >= 15000) && !this.isUserInRole('ROLE_FLEET'))
                            ) {
                                this.setState({invoiceTraditionalDialog: true});
                            } else if (
                                (rowData?.sapDocument &&
                                    rowData?.toPayAmount > 0 &&
                                    rowData?.amount <= 15000 &&
                                    this.isUserInRole('ROLE_FLEET')) ||
                                (rowData?.sapDocument &&
                                    rowData?.toPayAmount > 0 &&
                                    rowData?.toPayAmount < 15000 &&
                                    !this.isUserInRole('ROLE_FLEET'))
                            ) {
                                this.initPayment(rowData);
                            }
                        }}
                        variant={`next-button ${
                            rowData?.toPayAmount === 0
                                ? 'button-list-paid'
                                : ((!rowData?.sapDocument || (rowData?.toPayAmount > 0 && rowData?.amount > 15000)) &&
                                      this.isUserInRole('ROLE_FLEET')) ||
                                      (rowData.toPayAmount > 0 && this.isUserInRole('ROLE_ESPPOL')) ||
                                  ((!rowData?.sapDocument || rowData?.toPayAmount >= 15000) && !this.isUserInRole('ROLE_FLEET'))
                                ? 'button-list-traditional'
                                : (rowData?.sapDocument &&
                                      rowData?.toPayAmount > 0 &&
                                      rowData?.amount <= 15000 &&
                                      this.isUserInRole('ROLE_FLEET')) ||
                                  (rowData?.sapDocument &&
                                      rowData?.toPayAmount > 0 &&
                                      rowData?.toPayAmount < 15000 &&
                                      !this.isUserInRole('ROLE_FLEET'))
                                ? 'button-list-pay24'
                                : ''
                        }`}
                        key={'view-button'}
                        disabled={rowData?.toPayAmount === 0 || (this.user?.agreementSapRole === 'FLOTA' && !this.isUserHasPermission('PERMISSION_EDIT_INVOICES')) || 
                            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                        rendered={rowData?.toPayAmount >= 0 && currentUser.agreementType !== 'CASH'}
                    />
                    <ActionButton
                        rendered={rowData?.pdfGet === true}
                        label=''
                        iconSvg='ico_download_link_icon'
                        variant='invoice-download-pdf'
                        handleClick={(e) => {
                            e.preventDefault();
                            if (!!rowData.petraFileId) {
                                this.service
                                    .downloadInvoicePdf(rowData.petraFileId, rowData.invoiceNumber, rowData.invoiceDate)
                                    .then((response) => {
                                        saveAs(response, `${rowData.invoiceNumber}.pdf`);
                                    })
                                    .catch((err) => {
                                        this.showErrorMessage(t('invoice.downloadPdfError'));
                                    });
                            } else {
                                this.service
                                    .acceptOng(rowData.invoiceNumber, undefined, false)
                                    .then((res) => {
                                        if (!res.correctPassword) {
                                            this.showErrorMessage(t('invoice.downloadPdfError'));
                                        } else if (res.ongToAccept) {
                                            this.setState({showDialog: true, invoiceToDownload: res});
                                        } else {
                                            this.service
                                                .downloadInvoicePdf(rowData.petraFileId, rowData.invoiceNumber, rowData.invoiceDate)
                                                .then((response) => {
                                                    saveAs(response, `${rowData.invoiceNumber}.pdf`);
                                                })
                                                .catch((err) => {
                                                    this.showErrorMessage(t('invoice.downloadPdfError'));
                                                });
                                        }
                                    })
                                    .catch(() => {
                                        this.showErrorMessage(t('invoice.downloadPdfError'));
                                    });
                            }
                        }}
                        key={'download-invoice-button'}
                        disabled={(this.user?.agreementSapRole === 'FLOTA' && !this.isUserHasPermission('PERMISSION_EDIT_INVOICES')) || 
                            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                    />

                    {/* pobranie zalaczniku faktury flotowej dla faktur wystawionych wczesniej niz dziś */}
                    { this.isUserInRole('ROLE_FLEET') && moment(rowData.invoiceDate).isBefore(moment.now(), 'day') ?
                    <InvoiceAttachmentDownloadComponent
                    key={`print-button${this.getListTitle()}`}
                    reportFileNameBase={t(this.getListTitle())}
                    generateReport={this.generateReport.bind(this)}
                    rowData={rowData}
                    //disabled={!this.state.selectedList.length > 0}
                    label={''}
                    iconSvg={'ico_invoice_doc'}
                    variant='invoice-download-pdf'
                    pdf={false}
                    invoiceList={true}
                    messageFcn ={(a,b) => this.showDownloadAttachmentMessage(a,b)}
                />
                : null
                }

                </div>
                {rowData.toPayAmount !== rowData.amount && rowData.toPayAmount !== 0 ? (
                    <div className='row gy-2 mt-2'>
                        <span className='invoice-amount-to-pay col-12'>
                            {`${t('invoice.toPay')}: `}
                            <NumberFormat
                                value={rowData.toPayAmount}
                                displayType={'text'}
                                thousandSeparator=' '
                                decimalSeparator=','
                                fixedDecimalScale
                                decimalScale={2}
                                suffix={` ${t('currency.pln')}`}
                                renderText={(value) => value}
                            />
                        </span>
                        <span className='invoice-amount-paid col-12'>
                            {`${t('invoice.alreadyPaid')}: `}
                            <NumberFormat
                                value={rowData.amount - rowData.toPayAmount}
                                displayType={'text'}
                                thousandSeparator=' '
                                decimalSeparator=','
                                fixedDecimalScale
                                decimalScale={2}
                                suffix={` ${t('currency.pln')}`}
                                renderText={(value) => value}
                            />
                        </span>
                    </div>
                ) : null}
            </div>
        );
    }

    evInvoiceTemplate(rowData) {
        let array = [];
        if (rowData.invoiceNumber) {
            array.push(rowData.invoiceNumber);
        }
        if (rowData.ksefInvoice === true && rowData.ksefId) {
            array.push(rowData.ksefId);
        }
        if (rowData.ev === true) {
            return (
                <div>
                    <img className='card-icon' alt={t('invoice.evInvoice')} src={`/images/ico_ev_green_lightning.svg`} />
                    <span> {rowData.invoiceNumber} </span>
                    {rowData.ksefInvoice === true && rowData.ksefId ? <span> <br></br>{rowData.ksefId} </span> : null}
                </div>
            );
        } else {
            return array.map((item, index) => (
                <div key={index}>{`${item}`}</div>
            ))
        }

    }

    headerTemplateWithSlash(params) {
        return params.map((item, index) => (
            <div key={index}>
                {index === 0 ? item : `/${item}`}
            </div>
        ));
    }

    invoiceDateKsefDateTemplate(field, format, rowData) {
        let array = [];
        if (rowData[field] && moment(rowData[field]).isValid()) {
            array.push(moment(rowData[field]).format(format));
        }
        if (rowData.ksefInvoice === true && rowData.ksefDate && moment(rowData.ksefDate).isValid()) {
            array.push(moment(rowData.ksefDate).format(format));
        }
        if (array.length > 0) {
            return array.map((item, index) => (
                <div key={index}>
                    {index === 0 ? item : `${item}`}
                </div>
            ));
        } else return "";
    }

    isKsefOn(){
        const {xfxStartDate} = this.state;
        return (xfxStartDate !== undefined && moment(xfxStartDate).isSameOrBefore(moment()));
    }

    enumTemplate(enumType, field, rowData) {
        if (field === "ksefStatus") {
            if (rowData.ksefInvoice === true) {
                return this.translate(`${enumType}.${rowData[field]}`);
            } else {
                return '';
            }
        } else {
            if (rowData[field]) {
                return this.translate(`${enumType}.${rowData[field]}`);
            }
            return '';
        }

    }

    prepareColumns() {
        const { t } = this.props;
        const isKsefOn = this.isKsefOn();
        return [
            {
                field: 'invoiceDate',
                header: isKsefOn ? this.headerTemplateWithSlash([t('invoice.invoiceDate'), t('invoice.ksef.date')]) : t('invoice.invoiceDate'),
                sortable: true,
                body: this.invoiceDateKsefDateTemplate.bind(this, 'invoiceDate', 'DD-MM-YYYY'),
            },
            { field: 'invoiceNumber', 
              header: isKsefOn ? this.headerTemplateWithSlash([t('invoice.invoiceNumber'), t('invoice.ksef.number')]) : t('invoice.invoiceNumber'), 
              sortable: true, 
              body: this.evInvoiceTemplate.bind(this) },
            ...(isKsefOn
                ? [{
                    field: 'ksefStatus',
                    header: t('invoice.ksef.status'),
                    sortable: true,
                    body: this.enumTemplate.bind(this, 'KsefStatus', 'ksefStatus'),
                }]
                : []),
            { field: 'amount', header: t('invoice.amount'), sortable: true, body: this.invoiceAmountTemplate },
            { field: 'payDate', header: t('invoice.payDate'), sortable: true, body: this.invoicePayToTemplate },
            {
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ]
    }

    generateReport(format) {
        const {t, lazy} = this.props;
        const {selectAll} = this.state;
        const list = (this.hasFilter() && selectAll && lazy === false )? this.processData() : this.state.selectedList;
        if (format === 'csv') {
            const fields = [
                {value: this.dateTemplate.bind(this, 'invoiceDate', 'DD-MM-YYYY'), label: t('invoice.invoiceDate')},
                {value: 'invoiceNumber', label: t('invoice.invoiceNumber')},
                {value: 'amount', label: t('invoice.amountGross')},
                {value: 'amountVat', label: t('invoice.amountVat')},
                {value: amountNet.bind(this, false, t), label: t('invoice.amountNet')},
                {value: this.dateTemplate.bind(this, 'payDate', 'DD-MM-YYYY'), label: t('invoice.payDate')},
            ];
            return Promise.resolve(baseReportCsv(list, fields));
        } else {
            const columns = [
                {
                    header: t('invoice.invoiceDate'),
                    field: 'invoiceDate',
                    getColFunction: this.dateTemplate.bind(this, 'invoiceDate', 'DD-MM-YYYY'),
                },
                {
                    header: t('invoice.invoiceNumber'),
                    field: 'invoiceNumber',
                },
                {
                    header: t('invoice.amountGross'),
                    field: 'amount',
                    getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'amount', t) : null,
                },
                {
                    header: t('invoice.amountVat'),
                    field: 'amountVat',
                    getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'amountVat', t) : null,
                },
                {header: t('invoice.amountNet'), field: 'amountNet', getColFunction: amountNet.bind(this, format === 'pdf', t)},
                {header: t('invoice.payDate'), field: 'payDate', getColFunction: this.dateTemplate.bind(this, 'payDate', 'DD-MM-YYYY')},
            ];
            if (format === 'pdf') {
                const blob = baseReportPdf({list, title: t('invoice.listTitle'), columns, landscape: true}, t);
                return Promise.resolve(blob);
            } else if (format === 'ods' || format === 'xlsx') {
                const request = {};
                request.columns = columns;
                request.list = list;
                request.sheetName = t(this.getListTitle()).replaceAll(/[*?\][\\/]/g, ' ,');
                return Promise.resolve(baseXLSXReport(request, format));
            }
        }
    }

    prepareHeaderItems() {
        return [
            {type: 'LABEL', className: 'float-left'},
            {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                customRenderFunction: this.renderPrintButton,
            },
        ];
    }
    renderPrintButton() {
        const {t} = this.props;
        return (
            <PrintButtonComponent
                key={`print-button${this.getListTitle()}`}
                reportFileNameBase={t(this.getListTitle())}
                generateReport={this.generateReport.bind(this)}
                disabled={!this.state.selectedList.length > 0}
            />
        );
    }

    renderDialog() {
        const {t} = this.props;
        const {invoiceToDownload} = this.state;
        return invoiceToDownload !== undefined && invoiceToDownload !== null ? (
            <div>
                <div className='invoice-property'>
                    {`${t('invoice.invoiceNumberFilter')}: `}
                    <div className='invoice-property-value'>{invoiceToDownload?.positions[0]?.docNumber}</div>
                </div>
                <div className='invoice-property'>
                    {`${t('invoice.documentDate')}: `}
                    <div className='invoice-property-value'>
                        {moment(invoiceToDownload?.positions[0].docDate).format('DD-MM-YYYY')}
                    </div>{' '}
                </div>
                <div className='product-list'>
                    <div className='product-list-header'>
                        <div className='name'>{t('invoice.productName')}</div>
                        <div className='quantity'>{t('invoice.productAmount')}</div>
                    </div>
                    {invoiceToDownload?.positions !== null && invoiceToDownload?.positions.length > 0
                        ? invoiceToDownload?.positions?.map((el) => {
                              return (
                                  <div key={el.goodsName} className='product-list-row'>
                                      <div className='name'>{el.goodsName}</div>
                                      <div className='quantity'>{el.quantity}</div>
                                  </div>
                              );
                          })
                        : null}
                </div>
                <div className='button-row'>
                    <ActionButton
                        label={t('invoice.invoiceDownloadConfirm')}
                        variant='next-button pay24-button'
                        handleClick={(e) => {
                            e.preventDefault();
                        }}
                    />
                </div>
            </div>
        ) : null;
    }

    render() {
        const {t} = this.props;
        return (
            <div className='container-fluid invoice-list-container'>
                <BlockUi tag='div' blocking={this.state.pragmaLoading} loader={this.loader}>
                <BreadcrumbsItem to='/invoice-list'>{t('invoice.listName')}</BreadcrumbsItem>
                {this.renderPaymentDetails()}
                {this.renderAddToTrustedDevicesDialog()}
                {this.renderView()}
                {this.state.currentUser?.agreementType === 'PREPAID' ? this.renderP24Banner() : null}
                </BlockUi>
            </div>
        );
    }
    /*     openPopup(){
        popupIframe.src = `https://online.pragmago.pl/kalkulator-odroczone-terminy-platnosci?recommendation_code=${recommendationCode}${itemValue}`;

        popupOverlay.style.display = 'block';
    } */
    prepareIframe(rowdata) {
        const WARTOSC_PRZEDMIOTU = rowdata?.toPayAmount;
        let itemValue = WARTOSC_PRZEDMIOTU ? `&itemValue=${WARTOSC_PRZEDMIOTU}` : '';
        let recommendationCode = '779327';
        const popupOverlay = document.getElementById('popupOverlay');
        const popupIframe = document.getElementById('popupIframe');

        const openPopup = () => {
            popupIframe.src = `https://online.pragmago.pl/kalkulator-odroczone-terminy-platnosci?recommendation_code=${recommendationCode}${itemValue}`;
            popupOverlay.style.display = 'block';
            popupOverlay.style.border = '1px solid #1AB759';
        };
        const closePopup = () => {
            popupIframe.src = '';
            popupOverlay.style.display = 'none';
        };
        const openPragmaPopUp = document.getElementById('openPragmaPopUp');
        const closePopupButton = document.getElementById('closePopup');
        if (openPragmaPopUp && closePopupButton) {
            openPragmaPopUp.addEventListener('click', openPopup);
            closePopupButton.addEventListener('click', closePopup);
        }
    }


    renderView() {
        const {t} = this.props;
        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <Card
                    className='list-card'
                    // header={this.renderHeader()}
                >
                    <DivContainer colClass='row'>{this.renderFilter()}</DivContainer>
                    <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>
                    {this.renderDataTable(this.prepareColumns())}
                </Card>
                <CustomDialog
                    name='invoice-download-dialog'
                    className='invoice-download-dialog'
                    visible={this.state.showDialog}
                    viewMode={this.props.viewMode}
                    onHide={() => {
                        this.setState({showDialog: false, invoiceToDownload: undefined});
                    }}
                    modal
                    header={t('invoice.downloadInvoiceDialogHeader')}
                >
                    {this.renderDialog()}
                </CustomDialog>
                <CustomDialog
                    name='invoice-traditional-dialog'
                    className='confirm-dialog-width'
                    visible={this.state.invoiceTraditionalDialog}
                    viewMode={'VIEW'}
                    onHide={() => {
                        this.setState({invoiceTraditionalDialog: false});
                    }}
                    modal
                    header={t('invoice.payTraditional')}
                >
                    <Card
                        footer={() => (
                            <div className='footer-dialog-button-container'>
                                <ActionButton
                                    label={t('details.close')}
                                    variant='button save-button'
                                    handleClick={(e) => {
                                        e.preventDefault();
                                        this.setState({invoiceTraditionalDialog: false});
                                    }}
                                    key={'traditional-dialog-close'}
                                />
                            </div>
                        )}
                    >
                        <div>
                            <div className='invoice-property desc'>{this.isUserInRole('ROLE_ESPPOL') ? t('invoice.invoiceTraditional.esppol') : t('invoice.invoiceTraditional.desc')  }</div>
                            <div className='invoice-property'>
                                <span className='bold'>{`${t('invoice.invoiceTraditional.recepient')}:`}</span>
                                <div className='invoice-property-value'>{this.state.paymentRecipient}</div>
                            </div>
                            <div className='invoice-property bank-account'>
                                <span className='bold'>{`${t('invoice.invoiceTraditional.bankAccount')}:`}</span>
                                <div className='invoice-property-value'>
                                    {this.user.agreementBankAccountNumber}
                                    <CopyToClipboard
                                        text={
                                            !!this.user.agreementBankAccountNumber
                                                ? this.user.agreementBankAccountNumber.replace(/^\D+/g, '')
                                                : ''
                                        }
                                        onCopy={() => this.showSuccessMessage(t('balance.copyBankAccountSuccess'))}
                                    >
                                        <img src='/images/ico_copy.svg' className='card-icon' alt={t('balance.copyBankAccount')} />
                                    </CopyToClipboard>
                                </div>
                            </div>
                        </div>
                    </Card>
                </CustomDialog>

                {/* pragma dialog */}
                {this.state.invoicePragmaDialog && (
                    
             <CustomDialog
                        name='invoice-pragma-dialog'
                        className='invoice-pragma-dialog'
                        visible={this.state.invoicePragmaDialog}
                        viewMode={'VIEW'}
                        onHide={() => {
                            this.setState({
                                invoicePragmaDialog: false,
                                pragmaCosts: undefined,
                                pragmaAgreement: false,
                                element: {pragmaPaymentPeriod: undefined},
                            });
                        }}
                        modal
                        header={t('invoice.pragmaCalculator')}
                    >
                        <Card
                            footer={() => (
                                <div className='button-col'>
                                    <ActionButton
                                        label={t('invoice.pragmaSend')}
                                        variant='right-button save-button'
                                        handleClick={(e) => {
                                            e.preventDefault();
                                            this.sendInvoiceIdToPragma(
                                                this.state.invoicePragmaData,
                                                this.state.element.pragmaPaymentPeriod
                                            );
                                            this.setState({           
                                                invoicePragmaDialog: false,
                                                pragmaCosts: undefined,
                                                pragmaAgreement: false,
                                                element: {
                                                    pragmaPaymentPeriod: undefined,
                                                },
                                            });
                                        }}
                                        disabled={
                                            this.state.element.pragmaPaymentPeriod === undefined || this.state.pragmaAgreement === false
                                        }
                                        key={'traditional-dialog-close'}
                                    />
                                </div>
                            )}
                        >
                            <div>
                                <div className='invoice-property desc'>
                                    {t('invoice.pragmaFvValue')}
                                    <span className='invoice-property-value'>{this.state.invoicePragmaData?.toPayAmount + ' PLN'} </span>
                                </div>
                                <div className='invoice-property'>
                                    <span className='bold'>{t('invoice.pragmaDaysValue')}</span>
                                    <InputRadioButtonComponent
                                        id='pragmaPaymentPeriod'
                                        name='pragmaPaymentPeriod'
                                        label={'Okresy płatności'}
                                        colClass='col-md-12 pragmaPaymentPeriod'
                                        viewMode={'EDIT'}
                                        valueLabel='label'
                                        //valueLabel={t(`products.${value}`)}
                                        value={this.state.element.pragmaPaymentPeriod}
                                        options={this.state.pragmaPaymentPeriods}
                                        itemColClass={'col-md-4 col-sm-12 pragma-custom-label'}
                                        labelOnRight
                                        onChange={(a, b, c, d, e) => {
                                            this.setState({
                                                element: {
                                                    pragmaPaymentPeriod: c.value.value,
                                                },
                                            });

                                            this.countPragmaCosts(c.value.value, this.state.invoicePragmaData?.toPayAmount);
                                        }}
                                        showLabel={false}
                                        validator={this.validator}
                                        validators='required'
                                        rendered={true}
                                        valueKey='value'
                                        stateField={``}
                                    />
                                </div>

                                <div className='invoice-property'>
                                    {' '}
                                    {t('invoice.pragmaSummaryCost')}
                                    <span className='invoice-property-value'>
                                        {this.state.pragmaCosts !== undefined && this.state.pragmaCosts !== null
                                            ? ' ' + this.state.pragmaCosts + ' PLN'
                                            : ' 0 PLN'}
                                    </span>
                                </div>

                                <div className='invoice-pragma-offer-agreement'>{t('invoice.pragmaOfferInfo')} </div>

                                <InputCheckboxComponent
                                    id={'pragmaAgreement'}
                                    name='pragmaAgreement'
                                    label={t('invoice.pragmaOfferAgreement')}
                                    stateField=''
                                    labelOnRight
                                    value={this.state.pragmaAgreement}
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode={'EDIT'}
                                    validators={'required|accepted'}
                                    validatorLabel=''
                                    labelClassName='p-label'
                                    //required={true}
                                    renderRequired={true}
                                    colClass='col-width-auto'
                                />
                                 <div className='invoice-pragma-agreement'>{t('invoice.pragmaInfo')} </div>
                            </div>
                        </Card>
                    </CustomDialog>
                )}

                {/* pragma dialog */}
            </DivContainer>
        );
    }
}

InvoiceListContainer.defaultProps = {
    detailUrl: '/#/invoice/details',
    newUrl: '/#/invoice/create',
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
    hidePaymentDetails: false,
};

InvoiceListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    hidePaymentDetails: PropTypes.bool,
};

export default withTranslation()(InvoiceListContainer);
